<template>
  <div class="w-full">
    <div
      v-if="forgotPasswd == false"
      class="min-h-screen flex flex-col lg:flex-row"
    >
      <!-- Left Side - Form -->
      <div class="flex flex-col justify-center w-full lg:w-1/2 px-6 sm:px-12 md:px-20 lg:px-24 xl:px-32 py-12 bg-white relative">
        <div class="w-full max-w-md mx-auto">
          <!-- Logo -->
          <div class="mb-12 text-center">
            <img src="../assets/shipsen.png" alt="Shipsen" class="login-logo" />
          </div>

          <!-- Title -->
          <h1 class="login-title">
            Sign in
          </h1>
          <p class="mt-2 text-sm text-gray-600">
            Don't have an account?
            <button
              @click="landingPage"
              class="font-semibold login-link focus:outline-none transition duration-200"
            >
              Sign up
            </button>
          </p>

          <!-- Divider -->
          <div class="relative mt-8 mb-8">
            <div class="absolute inset-0 flex items-center">
              <div class="w-full border-t border-gray-400"></div>
            </div>
            <div class="relative flex justify-center text-sm">
              <span class="px-4 bg-white text-gray-600 uppercase tracking-wide text-xs">
                sign in with your credentials
              </span>
            </div>
          </div>

          <!-- Form -->
          <div>
            <!-- Email / Username -->
            <div class="mb-5">
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Email or Username
              </label>
              <input
                type="text"
                name="username"
                v-model="formData.username"
                placeholder="Enter your email or username"
                class="login-input"
              />
            </div>

            <!-- Password -->
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Password
              </label>
              <input
                type="password"
                name="password"
                @keyup.enter="trigger"
                v-model="formData.password"
                placeholder="Enter your password"
                class="login-input"
              />
            </div>

            <!-- Remember + Forgot -->
            <div class="flex items-center justify-between mb-8">
              <label class="flex items-center cursor-pointer">
                <input type="checkbox" class="login-checkbox" />
                <span class="ml-2 text-sm text-gray-600 select-none">Remember me</span>
              </label>
              <button
                @click="OpenPopUp"
                class="text-sm font-semibold login-link focus:outline-none transition duration-200"
              >
                Forgot password?
              </button>
            </div>

            <!-- Sign In Button -->
            <button
              @click="login"
              ref="sendReply"
              :disabled="loading"
              class="login-btn relative loidingconfirm"
            >
              <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              <span>Sign in</span>
              <svg class="ml-2 h-5 w-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Right Side - Decorative Panel -->
      <div class="hidden lg:flex lg:w-1/2 login-right-panel relative overflow-hidden">
        <!-- Background decorative shapes -->
        <div class="login-bg-shape login-bg-shape-1"></div>
        <div class="login-bg-shape login-bg-shape-2"></div>
        <div class="login-bg-shape login-bg-shape-3"></div>

        <div class="relative z-10 flex flex-col items-center justify-center w-full px-16 text-center">
          <!-- Decorative illustration -->
          <div class="mb-10">
            <svg class="login-illustration" viewBox="0 0 220 220" fill="none" xmlns="http://www.w3.org/2000/svg">
              <!-- Package/Box icon representing shipping -->
              <rect x="30" y="80" width="160" height="110" rx="8" fill="rgba(255,255,255,0.15)" stroke="rgba(255,255,255,0.3)" stroke-width="2"/>
              <path d="M30 105L110 65L190 105" stroke="rgba(255,255,255,0.4)" stroke-width="2" fill="rgba(255,255,255,0.08)"/>
              <line x1="110" y1="65" x2="110" y2="190" stroke="rgba(255,255,255,0.2)" stroke-width="2"/>
              <line x1="30" y1="105" x2="110" y2="145" stroke="rgba(255,255,255,0.15)" stroke-width="2"/>
              <line x1="190" y1="105" x2="110" y2="145" stroke="rgba(255,255,255,0.15)" stroke-width="2"/>
              <!-- Small decorative elements -->
              <circle cx="50" cy="50" r="4" fill="rgba(255,255,255,0.3)"/>
              <circle cx="170" cy="40" r="3" fill="rgba(255,255,255,0.2)"/>
              <circle cx="180" cy="70" r="2" fill="rgba(255,255,255,0.25)"/>
              <circle cx="40" cy="70" r="2.5" fill="rgba(255,255,255,0.2)"/>
              <!-- Arrow/shipping indicator -->
              <path d="M95 30L110 15L125 30" stroke="rgba(255,255,255,0.4)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              <line x1="110" y1="15" x2="110" y2="55" stroke="rgba(255,255,255,0.4)" stroke-width="2.5" stroke-linecap="round"/>
            </svg>
          </div>

          <!-- Quote text -->
          <h2 class="text-white text-2xl font-bold leading-tight mb-4">
            With Shipsen, Africa becomes close.
          </h2>
          <p class="login-right-subtitle">
            We offer a complete set of services — Distribution, warehousing, call center, packing and shipping, in different West and Central African countries.
          </p>
          <p class="login-right-tagline">
            We pick, pack, assemble and ship.
          </p>

          <!-- Decorative dots -->
          <div class="flex items-center mt-10">
            <span class="login-dot login-dot-active"></span>
            <span class="login-dot"></span>
            <span class="login-dot"></span>
          </div>
        </div>
      </div>

      <!-- Modal: Forgot Password -->
      <vue-modal-2 name="myModal" :headerOptions="{title: 'Find your email address'}" :noFooter="true" modalSize="md">
        <div v-if="valideUser == false" class="modal-footer px-5 border0-t">
          <div class="items-center justify-center flex rounded-full">
            <span
              class="w-1/4 text-sm text-white inline-flex items-center justify-center"
            >
              <img
                alt="..."
                class="w-full align-middle border p-3 rounded-full"
                src="../assets/shipsen-man1.jpg"
              />
            </span>
          </div>
          <div class="flex flex-col mb-6">
            <div class="mt-10 relative">
              <div
                class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400"
              >
                <span class="material-icons">email</span>
              </div>

              <input
                type="text"
                name="emailAddress"
                class="text-sm sm:text-base placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-2 focus:outline-none focus:border-blue-400"
                v-model="formData.forgotPasswdEmail"
                placeholder="Enter Your E-Mail Address"
              />
            </div>
          </div>

          <button
            @click="closePopUp('myModal')"
            class="flex mt-6 mb-2 text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
          >
            Cancel
          </button>
          <button
            @click="forgotPasswordUser"
            class="flex mt-6 mb-2 mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right"
          >
            Send verification code
          </button>
        </div>

        <div v-else class="modal-footer px-5 border0-t">
          <div class="items-center justify-center flex rounded-full">
            <span
              class="w-1/4 text-sm text-white inline-flex items-center justify-center"
            >
              <img
                alt="..."
                class="w-full align-middle border p-3 rounded-full"
                src="../assets/shipsen-man1.jpg"
              />
            </span>
          </div>
          <div class="flex flex-col mb-6">
            <div class="mt-2 relative">
              <div
                class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400"
              >
                <span class="material-icons">lock_outline</span>
              </div>
              <input
                type="text"
                name="verification code"
                class="text-sm sm:text-base placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-2 focus:outline-none focus:border-blue-400"
                v-model="formData.verify.code"
                placeholder="Enter code"
              />
            </div>
          </div>

          <button
            @click="closePopUp('myModal')"
            :disabled="loadingVerify"
            class="flex mt-6 mb-2 text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
          >
            Cancel
          </button>
          <button
            @click="validateVerificationCode"
            :disabled="loadingVerify"
            class="flex mt-6 mb-2 mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right relative loidingconfirm"
          >
            <loading :active.sync="loadingVerify" :is-full-page="fullPage"></loading>
            Confirm
          </button>
        </div>
      </vue-modal-2>

      <!-- Modal: Reset Password -->
      <vue-modal-2 name="ResetPassword" :headerOptions="{title: 'Reset password'}" :noFooter="true" modalSize="md">
        <div class="flex flex-col items-center justify-center">
          <div
            class="flex pt-0 flex-col bg-white px-4 py-8 rounded-md w-full max-w-md"
          >
            <div class="login-img">
              <img src="../assets/shipsen-man1.jpg" alt="Shipsen" />
            </div>

            <div
              class="font-medium self-center text-xl sm:text-2xl uppercase text-gray-800"
            >
              Login to your accoun
            </div>

            <div class="mt-10">
              <div>
                <div class="flex flex-col mb-6">
                  <label
                    for="email"
                    class="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
                    >New Password</label
                  >
                  <div class="relative">
                    <div
                      class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400"
                    >
                      <svg
                        class="h-6 w-6"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                        />
                      </svg>
                    </div>

                    <input
                      type="password"
                      name="username"
                      required
                      class="text-sm sm:text-base placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-2 focus:outline-none focus:border-blue-500"
                      v-model="formData.password"
                      :placeholder="'New password'"
                    />
                  </div>
                </div>

                <div class="flex flex-col mb-6">
                  <label
                    for="password"
                    class="mb-1 text-xs sm:text-sm tracking-wide text-gray-600"
                    >Confirm Password</label
                  >
                  <div class="relative">
                    <div
                      class="inline-flex items-center justify-center absolute left-0 top-0 h-full w-10 text-gray-400"
                    >
                      <span>
                        <svg
                          class="h-6 w-6"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                          />
                        </svg>
                      </span>
                    </div>

                    <input
                      type="password"
                      name="password"
                      required
                      v-model="formData.confirmPassword"
                      class="text-sm sm:text-base placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full py-2 focus:outline-none focus:border-blue-500"
                      placeholder="Confirm password"
                    />
                  </div>
                </div>

                <div class="flex w-full">
                  <button
                    @click="newPassword"
                    class="flex relative loidingconfirm items-center justify-center focus:outline-none text-white text-sm sm:text-base bg-blue-700 hover:bg-blue-700 rounded py-2 w-full transition duration-150 ease-in"
                    :disabled="loadingVerify"
                  >
                    <loading :active.sync="loadingVerify" :is-full-page="fullPage"></loading>
                    <span class="mr-2 uppercase">Continue</span>
                    <span>
                      <svg
                        class="h-6 w-6"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vue-modal-2>

      <!-- Modal: SMS Verification -->
      <vue-modal-2 name="smsSend" :headerOptions="{title: `Validation ${verificationType}`}" :noFooter="true" modalSize="md">
        <div class="flex flex-col w-full h-auto">
          <div class="bg-white rounded px-2 pb-2 flex flex-col">
            <loading :active.sync="loading" :is-full-page="fullPage"></loading>
            <fieldset>
              <h2 class="h2">Votre code de v&eacute;rification a &eacute;t&eacute; envoy&eacute; par {{ verificationType == "sms" ? `num&eacute;ro de t&eacute;l&eacute;phone` : "Email" }}</h2>
              <h3 class="h3">Entrez le code de confirmation ci-dessous</h3>

              <div class="fieldset">
                <label v-for="(code, index) of myCodesSms" :key="index" class="box">
                  <input class="field" type="text" placeholder="&#8226;" v-model="code.code" :name="'code-'+index" />
                </label>
              </div>
            </fieldset>

            <div class="flex p-2 mt-4">
              <div class="flex-auto flex flex-row-reverse">
                <button
                  :disabled="loadingVerify"
                  @click="verificationCodeSms()"
                  class="w-1/3 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none relative loidingconfirm"
                >
                  <loading :active.sync="loadingVerify" :is-full-page="fullPage"></loading>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </vue-modal-2>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loginUser: { type: Function },
  },
  mounted() {
    const fields = document.querySelectorAll(".field");
    fields.forEach((field) => {
      field.addEventListener('input', this.handleInputField);
    });
  },
  data() {
    return {
      formData: {
        forgotPasswdEmail: "",
        verify: {
          code: "",
        },
      },
      verificationType:"",
      myCodesSms: [{code:""},{code:""},{code:""},{code:""},{code:""}],
      forgotPasswd: false,
      valideUser: false,
      user: {},
      loading: false,
      fullPage: false,
      loadingVerify: false,
    };
  },
  methods: {
    trigger() {
      this.$refs.sendReply.click();
    },
    async newPassword(){
      console.log('new pas-----',this.formData)

      if(this.formData.password) this.formData.password=this.formData.password.trim();
      if(this.formData.confirmPassword) this.formData.confirmPassword=this.formData.confirmPassword.trim();

      if (this.formData.password && this.formData.confirmPassword && this.formData.forgotPasswdEmail && this.formData.verify.code && (this.formData.password == this.formData.confirmPassword)) {
        const data={
          email:this.formData.forgotPasswdEmail,
          password:this.formData.password,
          code:this.formData.verify.code,
          newPassword:true,
        }
        this.loadingVerify=true;
        const resultat = await this.$server.verificationCode("users", data);
        this.loadingVerify=false;
        console.log('resultat new pass',resultat)
        if (resultat && resultat.status==200) {
           this.$vm2.close("ResetPassword");;
        } else {
          alert(resultat.content, "warning");
        }
      } else {
        alert("Confirmation password does not match", "warning");
        return false;
      }

    },
    async forgotPasswordUser() {
      const data = {
        email: this.formData.forgotPasswdEmail.toLowerCase().trim(),
      };
      this.loadingVerify=true;
      const res = await this.$server.forgotPassword("users", data);
      this.loadingVerify=false;
      if (res && res.content._id) {
        this.valideUser = true;
        this.user = res.content;
      } else {
        this.$vm2.close("myModal");
        alert("Mail address incorrect", "warning");
        this.forgotPasswdEmail = "";
        this.user = {};
      }
    },
    async validateVerificationCode() {
      const data = {
        email: this.formData.forgotPasswdEmail.toLowerCase().trim(),
        verify: {
          code: this.formData.verify.code,
        },
      };
      this.loadingVerify=true;
      const resultat = await this.$server.verificationCode("users", data);
      this.loadingVerify=false;
      if (resultat && resultat.status==200) {
        this.valideUser = false;
         this.$vm2.close("myModal");
         this.$vm2.open("ResetPassword");
      } else {
        alert(resultat.content, "warning");
      }
    },
    getDomaine(link){
       let domain = window.location.hostname;
       let protocol = window.location.protocol;
       if(domain=="localhost") domain="localhost:8080";
       console.log('domaine=========> ',protocol+"://"+domain+"/"+link)
       window.location.href = "/"+link;
    },
    async login() {
      if(!this.formData.username || !this.formData.password){
         alert("l'email ou le mot de passe est vide", "warning");
         return false
      }
      const data = {
        email: this.formData.username.toLowerCase().trim(),
        username: this.formData.username.trim(),
        password: this.formData.password.trim(),
      };
      this.loading=true;
      const res = await this.$server.login("users", data);

      this.loading=false;

      if (res && res.content && res.content._id) {
        if (
          res.content.status == "deleted" ||
          res.content.status == "blocked"
        ) {
          alert("you don't access to the account ", "warning");
        } else {
           if(res.headers["Sms"]){
              this.formData.forgotPasswdEmail=res.content.email;
              this.verificationType = "email"
              this.$vm2.open("smsSend");

            }else this.redirectLinkUser(res,res.content);

          }
      } else {
        alert("username or password incorrect !!! ", "warning");
      }
    },
    async verificationCodeSms(){

      if(this.myCodesSms.filter(element => {return element.code }).map(el=>el.code).length <5){
        alert("Le code de vérification est requis ou comporte moins de 5 chiffre");
        return false;
      }

      let data = {
        email: this.formData.forgotPasswdEmail.toLowerCase().trim(),
        verify: {
          code: this.myCodesSms.filter(element => {return element.code  }).map(el=>el.code).reduce((accum, digit) => (accum * 1) + digit, 0),
        },
      };

      this.loadingVerify=true;
      const res = await this.$server.verificationCodeSecurite("users", data);
      this.loadingVerify=false;

      if (res.content && res.content._id) this.redirectLinkUser(res,res.content);
      else alert(res.content, "warning");

  },
  redirectLinkUser(res,user){
        let self = this;
          localStorage.setItem('pr-version',res.headers["version"]);
          if(!localStorage.getItem('countryW')) localStorage.setItem('countryW', res.content.warehouses[0].country||res.content.warehouses[0]);
          else{
            const dataW=res.content.warehouses.find(o => o.country === localStorage.getItem('countryW'));
            if(!dataW) localStorage.setItem('countryW', res.content.warehouses[0].country||res.content.warehouses[0]);
          }

          if (res.content.status == "active") {
            const token = res.headers["X-Auth-Token"];
            this.$jwtService.saveToken(token);
            if(res.content.type=='StockManager' || res.content.type=='Courier' || res.content.type=='Accountant') setTimeout(function() {self.getDomaine('shippings');}, 250);
            else if(res.content.type=='TeleConsultant') setTimeout(function() {self.getDomaine('orders/confirmation');}, 250);
            else if(res.content.type=='NRP')  setTimeout(function() {self.getDomaine('orders/confirmation');}, 250);
            else if(res.content.type=='CallenterManager')  setTimeout(function() {self.getDomaine('orders');}, 250);
            else if(res.content.type=='Subscription')  setTimeout(function() {self.getDomaine('users/new');}, 250);
            else if(res.content.type=='Sourcing')  setTimeout(function() {self.getDomaine('sourcings');}, 250);
            else{
              this.$router.push({ name: 'Home' })
              location.reload();
            }
          } else {
            const token = res.headers["X-Auth-Token"];
            this.$jwtService.saveToken(token);
            setTimeout(function() {self.getDomaine('profil');}, 250);
          }
    },
    handleInputField({ target }) {
      const fields = document.querySelectorAll(".field");
      const value = target.value.slice(0, 1);
      target.value = value;
      if(value && value.toString().length>1) return
      const step = value ? 1 : -1;
      const fieldIndex = [...fields].findIndex((field) => field === target);
      const focusToIndex = fieldIndex + step;
       console.log('value-----',value)
      if (focusToIndex < 0 || focusToIndex >= fields.length) return;

      fields[focusToIndex].focus();
  },
    landingPage() {
      location.href = "https://shipsen.com/";
    },
    async OpenPopUp() {
       this.$vm2.open("myModal");
    },
    closePopUp(name) {
       this.$vm2.close(name);
      if(name=='myModal') this.valideUser = false;
    },
  }
}
</script>

<style scoped>
/* ===== Login Input ===== */
.login-input {
  width: 100%;
  padding: 14px 16px;
  font-size: 14px;
  color: #1f2937;
  background-color: #f3f4f6;
  border: 2px solid transparent;
  border-radius: 12px;
  outline: none;
  transition: all 0.2s ease;
}
.login-input:focus {
  background-color: #fff;
  border-color: #4285f4;
  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.15);
}
.login-input::placeholder {
  color: #9ca3af;
}

/* ===== Checkbox ===== */
.login-checkbox {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 2px solid #d1d5db;
  cursor: pointer;
  accent-color: #4285f4;
}

/* ===== Links ===== */
.login-link {
  color: #4285f4;
}
.login-link:hover {
  color: #3367d6;
}

/* ===== Login Button ===== */
.login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #4285f4 0%, #5a9cf6 100%);
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(66, 133, 244, 0.35);
  letter-spacing: 0.025em;
}
.login-btn:hover {
  background: linear-gradient(135deg, #3367d6 0%, #4285f4 100%);
  box-shadow: 0 6px 20px rgba(66, 133, 244, 0.45);
  transform: translateY(-1px);
}
.login-btn:active {
  transform: translateY(0);
}
.login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* ===== Logo ===== */
.login-logo {
  height: 80px;
  width: auto;
  object-fit: contain;
  margin: 0 auto;
  display: block;
}

/* ===== Title ===== */
.login-title {
  font-size: 2rem;
  font-weight: 800;
  color: #111827;
  letter-spacing: -0.025em;
  line-height: 1.2;
}

/* ===== Right Panel ===== */
.login-right-panel {
  background: linear-gradient(135deg, #1a3a6e 0%, #0d2247 50%, #0a1a3a 100%);
}

/* ===== Right Panel Text ===== */
.login-right-subtitle {
  color: rgba(255, 255, 255, 0.65);
  font-size: 1rem;
  line-height: 1.7;
  max-width: 400px;
  margin: 0 auto;
}
.login-right-tagline {
  color: #4285f4;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-top: 16px;
}

/* ===== Background Shapes ===== */
.login-bg-shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.08;
}
.login-bg-shape-1 {
  width: 400px;
  height: 400px;
  background: #4285f4;
  top: -100px;
  right: -100px;
  animation: floatShape 8s ease-in-out infinite;
}
.login-bg-shape-2 {
  width: 300px;
  height: 300px;
  background: #4285f4;
  bottom: -50px;
  left: -80px;
  animation: floatShape 10s ease-in-out infinite reverse;
}
.login-bg-shape-3 {
  width: 200px;
  height: 200px;
  background: #7aaffc;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: floatShape 12s ease-in-out infinite;
}

@keyframes floatShape {
  0%, 100% { transform: translate(0, 0); }
  33% { transform: translate(15px, -20px); }
  66% { transform: translate(-10px, 15px); }
}

/* ===== Illustration ===== */
.login-illustration {
  width: 180px;
  height: 180px;
  opacity: 0.9;
}

/* ===== Dots ===== */
.login-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  margin: 0 4px;
  transition: all 0.3s ease;
}
.login-dot-active {
  width: 24px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.8);
}

/* ===== Verification Code Styles ===== */
fieldset {
  text-align: center;
}
.fieldset {
  position: relative;
  display: grid;
  grid-auto-flow: column;
  justify-content: center;
  column-gap: 12px;
  border-radius: 6px;
  overflow: hidden;
  will-change: transform;
  padding: 6px;
  margin: -6px;
}
.fieldset::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  transform: translateX(-100%);
}
.box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  width: 42px;
  border-radius: 6px;
  box-shadow: 0 0 6px 1px hsl(240deg 54% 61% / 49%);
  overflow: hidden;
  will-change: transform;
}
.box:focus-within {
  box-shadow: 0 0 6px 1px hsla(240, 54%, 61%, 0.2), 0 0 0 2px hsla(240, 54%, 61%, 0.6);
}
.box::before,
.box::after {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  border-radius: -6px;
  overflow: hidden;
}
.box::before {
  background: hsl(240, 54%, 97%);
  z-index: 1;
}
.box::after {
  transform: translateY(100%);
  opacity: 0;
  z-index: 10;
}
.field {
  position: relative;
  border: 0;
  outline: 0;
  font-size: 25.21px;
  line-height: 42px;
  color: hsl(0deg 0% 20%);
  background-color: transparent;
  text-align: center;
  z-index: 100;
}
.field::placeholder {
  color: hsl(240, 54%, 87%);
}
.h2 {
  font-family: 'Open Sans', sans-serif;
  font-weight: 800;
  font-size: 15px;
  color: #2C3E50;
  margin: 10px 0;
}
.h3 {
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-style: italic;
  font-size: 15px;
  color: #666;
  margin-bottom: 20px;
}
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}
dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}
@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.login-img {
  height: auto;
  width: 157px;
  margin: 0 auto 10px;
  display: block;
  box-sizing: border-box;
  text-align: center;
}
</style>
